import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function FeatureIcon({ slug, className, customImage }) {
  const data = useStaticQuery(graphql`
    {
      landingPages: allContentfulLandingPage(filter: { pageVariant: { in: ["Showcase Page", "Feature Page"] } }) {
        nodes {
          alt: slug
          pageHeader {
            icon {
              gatsbyImageData(width: 104, quality: 100, layout: CONSTRAINED)
            }
          }
        }
      }
      local: allFile(filter: { extension: { regex: "/(jpg)|(jpeg)|(png)/" }, relativeDirectory: { eq: "nav/icons" } }) {
        nodes {
          alt: name
          icon: childImageSharp {
            gatsbyImageData(width: 104, quality: 100, layout: CONSTRAINED)
          }
        }
      }
    }
  `);

  const contentfulNodes = data?.landingPages?.nodes || [];
  const localNodes = data?.local?.nodes || [];

  const formattedContentfulNodes = contentfulNodes.map((node) => ({
    alt: node?.alt,
    icon: node?.pageHeader?.icon,
  }));

  const feature = [...formattedContentfulNodes, ...localNodes].find((node) => node.alt === slug);

  if (!feature?.icon) return null;

  return (
    <GatsbyImage
      image={getImage(customImage ? customImage : feature.icon)}
      className={className}
      imgStyle={{ objectFit: "contain" }}
      alt={`${feature.alt} icon`}
    />
  );
}
